import OPTION_TOOLTIPS from "../schema/optionTooltips"

// Merge the centralized per-option tooltips (schema/optionTooltips) into an option list,
// only where the option has no inline tooltip of its own. Read by chip-multi (the tag's
// info icon) and select (the dropdown option's info icon).
export const mergeOptionTooltips = (opts, questionKey) => {
  const map = OPTION_TOOLTIPS[questionKey]
  if (!map) return opts
  return opts.map((o) => (o.tooltip || !map[o.value] ? o : { ...o, tooltip: map[o.value] }))
}
